export default __webpack_public_path__ + "static/media/team_croucher.08ab7821.jpg";